import styled, { css } from 'styled-components'

const StyledHighlightedTableRow = styled.tr`
  ${props =>
    props.highlight &&
    css`
      td {
        background-color: ${props.highlight};
      }

      .ant-table-cell-fix-left {
        background-color: ${props.highlight};
      }
    `};

  ${props =>
    !props.isSelected &&
    !props.isCellHighlightDisabled &&
    css`
      .cell-low-certainty {
        background-color: #ffedd0;
      }
    `};

  ${props =>
    props.isSelected &&
    css`
      background-color: #fcf7c8;

      td {
        border-top: 1px solid #222 !important;
        border-bottom: 1px solid #222 !important;
      }

      .ant-table-cell-fix-left {
        background-color: #fcf7c8 !important;
      }
    `};
`

export default StyledHighlightedTableRow
